/* eslint-disable react/no-unknown-property */
import PropTypes, { element, func } from "prop-types";
import React, { useContext, useEffect, useState, useRef } from "react";
import { Link } from "react-router-dom";
import { FaEye } from "react-icons/fa";
import {
  Card,
  CardBody,
  Col,
  Row,
  Badge,
  UncontrolledTooltip,
  Button,
} from "reactstrap";
import { Table, Thead, Tbody, Tr, Th, Td } from "react-super-responsive-table";
import "../../assets/scss/style.css";
import * as Yup from "yup";
import DateRangePicker from "react-bootstrap-daterangepicker";
import { CInputGroup, CInputGroupText } from "@coreui/react";
import { useFormik, Formik, Field, FieldArray } from "formik";
import Schedule from "../../assets/images/Schedule.svg";
import { StandardPickerDateFormat } from "common/utility";
import calendarremovelines from "../../assets/images/calendar-remove-lines.svg";
import avatar from "../../assets/images/users/dummy.png";
import "flatpickr/dist/themes/material_blue.css";
import { withTranslation } from "react-i18next";
import { LoaderContext } from "context/ContextProvider";
import axios from "axios";
import { toast } from "react-hot-toast";
import { dateformat, longStringConvertToShort } from "admin/commonFunction";
import Pagination, {
  bootstrap5PaginationPreset,
} from "react-responsive-pagination";
import {
  getAllUser,
  blockUnblockUser,
  
} from "services/userServices";
import { successMsgHandler } from "common/successMsgHandler";
import { getAllUsers, getDashboardStats, saveUser } from "services/services";
import AddUser from "./addUser";
import { fireToast } from "common/toast";
import { deleteClientUser, updateUser } from "services/userServices";

const Users = ({ t }) => {
  // document.title = "Users";
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  console.log(BASE_URL, "BASE_URL");
  const [dateFilter, setDateFilter] = useState([]);
  const [listingData, setData] = useState([]);
  const [searchName, setSearchName] = useState("");
  const [statusFilter, setStatusFilter] = useState("");
  const [kycStatusFilter, setKycStatusFilter] = useState("");
  const [calendarIsShowing, setCalendarIsShowing] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const [loaderStatus, setLoaderStatus] = useState(true);
  let [incermentInd, setIncrementInd] = useState(1);
  const [statsData, setStatsData] = useState({});
  const [loading, setloading] = useState(false);
  const [show, setShow] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [editId, setEditId] = useState(null);
  const [submitting, setSubmitting] = useState(false);
  const[blockFilter,setBlockFilter] =useState("");
  const handleClose = () => {
    setShow(false);
  };
  const [formikValues, setFormikValues] = useState({
    email: "",
    mobile: "",
  });
  const perPage = 10;

  //fetch users
  const fetchData = (
    pagenumber,
    pagelimit,
    search = "",
    dateFilter = [],
    status = "",
    blockFilter = ""
  ) => {
    try {
      setLoaderStatus(true);
      const [fromDate, toDate] = dateFilter || [];
  
      getAllUser(
        pagenumber,
        pagelimit,
        search,
        fromDate || "",
        toDate || "",
        status
      ).then((res) => {
        let items = res.data.items || [];
  
        if (blockFilter === "blocked") {
          items = items.filter(user => user.isBlocked);
        } else if (blockFilter === "unblocked") {
          items = items.filter(user => !user.isBlocked);
        }
  
        setData(items);
        let pageCount = Math.ceil(res.data.total / perPage);
        setTotalCount(pageCount);
        setLoaderStatus(false);
      });
    } catch (err) {
      setLoaderStatus(false);
      console.log(err);
    }
  };
  
  const getDashboardInfo = async () => {
    try {
      setloading(true);
      let response = await getDashboardStats();
      if (response.status == 200) {
        console.log(response?.data, "response?.data");

        setStatsData(response?.data);
        setloading(false);
      }
    } catch (error) {
      setloading(false);
      console.log(error);
      // getDashboardInfo();
    }
  };
  useEffect(() => {
    getDashboardInfo();
  }, []);

  useEffect(() => {
    fetchData(currentPage, perPage);
  }, []);

  const formik = useFormik({
    initialValues: formikValues,
    enableReinitialize: true,
    validationSchema: Yup.object({
      email: Yup.string()
        .email("Invalid Email")
        .required(t("Email is required")),
      mobile: Yup.string()
        .matches(/^\+?[0-9\-\s()]{7,20}$/, t("Invalid phone number"))
        .nullable(),
    }),
    onSubmit: (values) => {
      handleFormSubmit(values);
    },
  });

  const handleFormSubmit = async (values) => {
    try {
      setSubmitting(true);
      if (isEdit && editId) {
        await updateUser(editId, values).then((res) => {
          setSubmitting(false);
          toast.success(t(`${successMsgHandler(res.message)}`));
          handleClose();
          setIsEdit(false);
          setEditId(null);
          fetchData(1, perPage, searchName, dateFilter, statusFilter, kycStatusFilter);
        });
      } else {
        await saveUser(values).then((res) => {
          setSubmitting(false);
          toast.success(t(`${successMsgHandler(res.message)}`));
          handleClose();
          fetchData(1, perPage, searchName, dateFilter, statusFilter, kycStatusFilter);
        });
      }
    } catch (err) {
      setSubmitting(false);
      console.log(err);
              fireToast("error", "An error occurred!");
    }
  };

  const handlePageClick = (page) => {
    setCurrentPage(page);
    fetchData(page, perPage, searchName, dateFilter, statusFilter);
  };

  const [typingTimeout, setTypingTimeout] = useState(0);
  const handleSearchClick = (e) => {
    const value = e.target.value;
    setSearchName(value);
    setCurrentPage(1);
    clearTimeout(typingTimeout);
    const timeoutId = setTimeout(() => {
      fetchData(1, perPage, e.target.value, dateFilter, statusFilter);
    }, 500);

    setTypingTimeout(timeoutId);

    // setSearchName(event.target.value)
    // setCurrentPage(1)
    // fetchData(1, perPage, event.target.value, statusFilter)
  };

  const handleStatusFilter = (e) => {
    setStatusFilter(e.target.value);
    if (e.target.value != "") {
      fetchData(1, perPage, searchName, dateFilter, e.target.value);
    } else {
      fetchData(1, perPage, searchName, dateFilter, "");
    }
  };

  const dateFilterChange = (e, picker) => {
    const filter = [
      picker.startDate.format("YYYY-MM-DD"),
      picker.endDate.format("YYYY-MM-DD"),
    ];
    setDateFilter(filter);
    fetchData(1, perPage, searchName, filter, statusFilter, kycStatusFilter);
  };

  const deleteUser = (userId) => {
    deleteClientUser({
      params: { userId: userId },
    })
      .then(function (response) {
        // Optimistically remove the user from the table
        setData(prev => prev.filter(user => (user.id || user._id) !== userId));
        // Show success alert
        toast.success(t(response?.message || "User Deleted successfully"));
      })
      .catch(function (error) {
        toast.error(error.response.data.error);
      });
  };

  //delete Job
  const ConfirmDeleteUser = (userId) => {
    // let URL = BASE_URL + "user/delete/" + userId
    Swal.fire({
      title: t("Are you sure?"),
      text: t("you want to delete this user!"),
      // icon: "warning",
      customClass: {
        popup: "my-swal-popup",
      },
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: t("Yes, delete it!"),
      cancelButtonText: t("Cancel"),
    }).then((result) => {
      if (result.isConfirmed) {
        deleteUser(userId);
      }
    });
  };

  const handleChangeCheck = async (id, check) => {
    console.log(check);
    blockUnblockUser(id, check)

      .then(function (res) {
        toast.success(t(res?.message || "User status updated successfully"));
        setData(prev =>
          prev.map(user =>
            (user.id === id || user._id === id)
              ? { ...user, isBlocked: check }
              : user
          )
        );
      })
      .catch(function (error) {
        toast.error(error?.response?.data?.error || "Something went wrong");
      });
  };
  

  const reports = [
    {
      title: "Todays Users",
      iconClass: "bx-group",
      description: statsData?.today,
    },
    {
      title: "Last 7 Days Users",
      iconClass: "bx-group",
      description: statsData?.last7Days,
    },
    {
      title: "Last 30 Days Users",
      iconClass: "bx-group",
      description: statsData?.lastMonth,
    },
    {
      title: "Total Users",
      iconClass: "bx-group",
      description: statsData?.total,
    },
  ];
  const inputRef = useRef(null);

  return (
    <React.Fragment>
      <AddUser  
        show={show}
        handleClose={() => { setShow(false); setIsEdit(false); setEditId(null); }}
        formik={formik}
        submitting={submitting}
        isEdit={isEdit}
      />
      <div className="page-content">
        <div className="container-fluid">
          <Row>
            {/* <Col xl="12">
              <Row>
                {reports.map((report, key) => (
                  <Col md="3" key={"_col_" + key}>
                    <Card className="mini-stats-wid">
                      <CardBody>
                        <div className="d-flex">
                          <div className="flex-grow-1">
                            <p className="text-muted fw-medium">
                              {report.title}
                            </p>
                            <h4 className="mb-0">
                              {report.description
                                ? report.description
                                : "......"}
                            </h4>
                          </div>
                          <div className="avatar-sm rounded-circle bg-primary align-self-center mini-stat-icon">
                            <span
                              className="avatar-title rounded-circle"
                              style={{ background: "#01A54F" }}
                            >
                              <i
                                className={
                                  "bx " + report.iconClass + " font-size-24"
                                }
                              ></i>
                            </span>
                          </div>
                        </div>
                      </CardBody>
                    </Card>
                  </Col>
                ))}
              </Row>
            </Col> */}
            <Col lg="12">
              <Card className="card-transparent">
                <div className="mb-3">
                  <Row className="d-flex align-items-center">
                    <Col lg="4">
                      <h5 className=" text-color-gredient"> {t("Users")} </h5>
                    </Col>
                    <Col
                      lg="8"
                      className="d-flex align-items-center justify-content-end"
                    >
                      <div className="common-filters date-filter me-xxl-2 my-3 my-xxl-0 d-inline-block">
                        <label htmlFor="search-bar-0" className="w-100 m-0">
                          <span id="search-bar-0-label" className="sr-only">
                            Filter by date
                          </span>
                          <CInputGroup className="">
                            <DateRangePicker
                              // initialSettings={{ startDate: '1/1/2014', endDate: '3/1/2014' }}
                              onApply={dateFilterChange}
                              // onCancel={}
                              onShow={() => setCalendarIsShowing(true)}
                              onHide={() => setCalendarIsShowing(false)}
                            >
                              <input
                                ref={inputRef}
                                placeholder={t("Filter by Date")}
                                className="form-control"
                                readOnly={true}
                                value={
                                  dateFilter.length
                                    ? `${StandardPickerDateFormat(
                                        dateFilter[0]
                                      )} - ${StandardPickerDateFormat(
                                        dateFilter[1]
                                      )}`
                                    : ""
                                }
                              />
                            </DateRangePicker>
                            <CInputGroupText>
                              <img
                                onClick={() => {
                                  if (!calendarIsShowing && dateFilter.length) {
                                    setDateFilter([]);
                                    fetchData(
                                      1,
                                      perPage,
                                      searchName,
                                      [],
                                      statusFilter,
                                      ""
                                    );
                                  }
                                }}
                                src={
                                  calendarIsShowing
                                    ? calendarremovelines
                                    : dateFilter.length
                                    ? calendarremovelines
                                    : Schedule
                                }
                                alt=""
                                width={20}
                              />
                            </CInputGroupText>
                          </CInputGroup>
                        </label>
                      </div>
                      <div className="common-filters search-box me-xxl-2 my-3 my-xxl-0 d-inline-block">
                        <div className="position-relative">
                          <label
                            htmlFor="search-bar-0"
                            className="search-label mb-0"
                          >
                            <span id="search-bar-0-label" className="sr-only">
                              Search this table
                            </span>
                            <input
                              id="search-bar-0"
                              type="search"
                              className="form-control"
                              placeholder={`${t("Search")}...`}
                              style={{ borderRadius: "4px" }}
                              onChange={handleSearchClick}
                            />
                          </label>
                          <i className="bx bx-search-alt search-icon"></i>
                        </div>
                      </div>
                      <div className="common-filters search-box me-xxl-2 my-3 my-xxl-0 d-inline-block">
                        {/* <Button
                          type="button"
                          className="btn all-common-btn w-md"
                          onClick={() => {
                            setFormikValues({
                              email: "",
                              mobile: "",
                            });
                            formik.resetForm();
                            setIsEdit(false);
                            setEditId(null);
                            setShow(true);
                          }}
                        >
                          Add New User
                      </Button> */}
                    </div>
                    <div className="me-xxl-2 my-3 my-xxl-0 d-inline-block">
                     <select
                       className="form-control select2 mb-xxl-0"
                       style={{ width: "165px" }}
                       value={blockFilter}
                       onChange={(e) => {
                         setBlockFilter(e.target.value);
                         fetchData(
                           1,
                           perPage,
                           searchName,
                           dateFilter,
                           statusFilter,
                           e.target.value
                         );
                       }}
                     >
                       <option value="">All Users</option>
                       <option value="unblocked">Unblocked Users</option>
                       <option value="blocked">Blocked Users</option>
                     </select>
                     </ div>
                      {/* <div className="me-xxl-2 my-3 my-xxl-0 d-inline-block">
                          <select
                            className="form-control select2 mb-xxl-0"
                            style={{ width: "165px" }}
                            onChange={handleStatusFilter}
                          >
                            <option value="">All</option>
                            <option value="pending">Pending</option>
                            <option value="sent">Completed</option>
                          </select>
                        </div> */}
                      {/* <div className="common-filters me-xxl-2 my-3 my-xxl-0 d-inline-block">
                          <button
                            type="button"
                            className="btn all-common-btn w-md"
                            onClick={() =>
                              fetchData(
                                currentPage,
                                perPage,
                                searchName,
                                dateFilter,
                                statusFilter,
                                "true"
                              )
                            }
                          >
                            {t("Export CSV")}
                          </button>
                        </div> */}
                      {/* 
                        <div className="me-xxl-2 my-3 my-xxl-0 d-inline-block">
                          <select
                            className="form-control select2 mb-xxl-0"
                            style={{ width: "165px" }}
                            onChange={handleKycStatusFilter}
                          >
                            <option value="">Select KYC</option>
                            <option value="PENDING">Pending</option>
                            <option value="INPROGRESS">In-progress</option>
                            <option value="COMPLETED">Completed</option>
                            <option value="REJECTED">Rejected</option>
                          </select>
                        </div> */}
                    </Col>
                  </Row>
                </div>
                <div className="table-responsive">
                  <Table
                    id="tech-companies-1"
                    className="table common-table table-nowrap table-bordered"
                  >
                    <Thead>
                      <Tr>
                        <Th>Sr. No.</Th>
                        <Th>{t("Name")}</Th>
                        <Th>{t("Email")}</Th>
                        <Th>{t("Phone Number")}</Th>
                        <Th>{t("Created At")}</Th>
                        <Th>{t("Action")}</Th>
                      </Tr>
                    </Thead>
                    <Tbody>
                      {loaderStatus ? (
                        <Tr>
                          <Td colSpan="5"> {t("Loading")} ... </Td>
                        </Tr>
                      ) : listingData.length != 0 ? (
                        listingData.map((element, index) => {
                          console.log(element.isBlocked,"element.isBlocked")
                          currentPage > 1
                            ? (incermentInd = (currentPage - 1) * perPage + 1)
                            : 0;
                          return (
                            <tr key={index}>
                              <td>
                                <span className="co-name">
                                  {" "}
                                  {incermentInd + index}{" "}
                                </span>
                              </td>
                              <td>
                               {element?.name}
                              </td>
                              <td>{element?.email ? element?.email : "-"}</td>
                              <td>{element?.mobile ? element?.mobile : "-"}</td>
                              <td>{dateformat(element.createdAt)}</td>
                              <td>
                                   <div className="d-flex align-items-center">
                                      {/* Properties Eye Button */}
                                     {/* Properties Eye Button */}
                                  <Link
                                    to={`/admin/users/${element.id || element._id}/properties`}
                                    id={`propertiesTooltip-${element.id || element._id}`}
                                    className="action-btn me-3"
                                  >
                                    <i className="bx bx-show action-icon-lg"></i>
                                  </Link>
                                  <UncontrolledTooltip
                                    placement="top"
                                    target={`propertiesTooltip-${element.id || element._id}`}
                                  >
                                    View user properties
                                  </UncontrolledTooltip>
                                  
                                  {/* Enquiries Chat Button */}
                                  <Link
                                    to={`/admin/users/${element.id || element._id}/enquiries`}
                                    id={`enquiriesTooltip-${element.id || element._id}`}
                                    className="action-btn me-3"
                                  >
                                    <i className="bx bx-chat action-icon-lg"></i>
                                  </Link>
                                  <UncontrolledTooltip
                                    placement="top"
                                    target={`enquiriesTooltip-${element.id || element._id}`}
                                  >
                                    View user enquiries
                                  </UncontrolledTooltip>
                                  

    {/* Block/Unblock */}
    <div
      id={`toggleTooltip-${element.id || element._id}`}
      className="me-2 p-1 btn"
      onClick={() => {
        handleChangeCheck(
          element.id || element._id,
          !Boolean(element?.isBlocked)
        );
      }}
    >
      <i
        className={`mdi ${
          Boolean(element?.isBlocked)
            ? "mdi-toggle-switch"
            : "mdi-toggle-switch-off"
        } common-icons`}
        style={{ fontSize: "25px" }}
      />
      <UncontrolledTooltip
        placement="top"
        target={`toggleTooltip-${element.id || element._id}`}
        transition={{ timeout: 150 }}
        fade={false}
      >
        {"Block/Unblock"}
      </UncontrolledTooltip>
    </div>

    {/* Delete */}
    {/* <div
      id={`deleteTooltip-${element.id || element._id}`}
      className="p-1 btn"
      onClick={() => {
        ConfirmDeleteUser(element.id || element._id);
      }}
    >
      <i className="mdi mdi-delete-outline common-icons" />
      <UncontrolledTooltip
        placement="top"
        target={`deleteTooltip-${element.id || element._id}`}
        transition={{ timeout: 150 }}
        fade={false}
      >
        {"Delete"}
      </UncontrolledTooltip>
    </div> */}

    {/* Edit */}
    <div
      id={`editTooltip-${element.id || element._id}`}
      className="p-1 btn"
      onClick={() => {
        setIsEdit(true);
        setEditId(element.id || element._id);
        setFormikValues({ email: element?.email || "", mobile: element?.mobile || "" });
        formik.setValues({ email: element?.email || "", mobile: element?.mobile || "" });
        setShow(true);
      }}
    >
      <i className="bx bx-edit-alt common-icons" />
      <UncontrolledTooltip
        placement="top"
        target={`editTooltip-${element.id || element._id}`}
        transition={{ timeout: 150 }}
        fade={false}
      >
        {"Edit"}
      </UncontrolledTooltip>
    </div>
  </div>
</td>
                            </tr>
                          );
                        })
                      ) : (
                        <tr>
                          <td colSpan={5}><p className="text-center m-0">{t("No Records Found")}</p></td>
                        </tr>
                      )}
                    </Tbody>
                  </Table>
                </div>
                <Row className="mt-2">
                  <Col md={9}></Col>
                  <Col md={3}>
                    <Pagination
                      {...bootstrap5PaginationPreset}
                      current={currentPage}
                      total={totalCount}
                      onPageChange={(page) => handlePageClick(page)}
                      className="pagination justify-content-end gap-1"
                    />
                  </Col>
                </Row>
              </Card>
            </Col>
          </Row>
        </div>
      </div>
    </React.Fragment>
  );
};

Users.propTypes = {
  t: PropTypes.any,
  chartsData: PropTypes.any,
  onGetChartsData: PropTypes.func,
};

export default withTranslation()(Users);
